import script from "./PaymentPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentPopup.vue?vue&type=script&setup=true&lang=js"

import "./PaymentPopup.vue?vue&type=style&index=0&id=69a14352&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69a14352"]])

export default __exports__